module.exports = __webpack_public_path__ + "static/media/(000022).9b77c051.jpg";